/** Links públicos das lojas de aplicativos (site institucional). */
export const APP_STORE_APPLE_URL =
  'https://apps.apple.com/br/app/ufokko/id6761654934';

/** Ficha pública na Google Play (package com.ufokko.mobile). */
export const APP_STORE_ANDROID_URL =
  'https://play.google.com/store/apps/details?id=com.ufokko.mobile&hl=pt_BR';
